exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-ModalButtonList-Root {\n  display: block;\n  text-align: center;\n  margin-top: 40px;\n}\n", ""]);

// exports
